module.exports = __webpack_public_path__ + "static/media/caret_down.6a95d665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/caret_down.svg
// module id = 843
// module chunks = 0